import $ from "jquery";

import "../scss/page.scss";

import "../scss/single-post.scss";

import "jquery-match-height";

/**
 * Ticket #772: [UI] [Blog] Add software outsourcing badge to article
 * Description: Inserting a badge to a specific section of the article content
 */
$('.single-post.postid-11930 .entry-content p:last-child').append('<a href="https://softwareoutsourcing.com/" style="float:right;" class="post-img-append"><img src="https://www.createit.com/wp-content/uploads/2024/01/software-outsourcing-journal.png"></a>');

$(window).on('load', function(){
    if($('.bd_toc_content_list_item li').length){
        $('.blog__sidebar-box--toc').removeClass('blog__sidebar-box--hide');
    }
});